export default __webpack_public_path__ + "static/media/flowers-no-2.494aa783.ogg";